import { t } from '@avalara/bat-apps-shared/i18n';
import { getFormFieldValidations } from '@avalara/bat-apps-shared/lib/form-validation';

import type { ValidationError } from '@avalara/types/billingContact';
import type { CountryModel } from 'types/avatax';

export const zuoraRegions = {
  // https://knowledgecenter.zuora.com/Quick_References/Country%2C_State%2C_and_Province_Codes/C_Canadian_Province_Names_and_2-Digit_Codes
  CA: [
    'Alberta',
    'British Columbia',
    'Manitoba',
    'New Brunswick',
    'Newfoundland and Labrador',
    'Northwest Territories',
    'Nova Scotia',
    'Nunavut',
    'Ontario',
    'Prince Edward Island',
    'Quebec',
    'Saskatchewan',
    'Yukon',
  ],
  // https://knowledgecenter.zuora.com/Quick_References/Country%2C_State%2C_and_Province_Codes/B_State_Names_and_2-Digit_Codes
  US: [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'Armed Forces America',
    'Armed Forces Pacific',
    'Armed Forces',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Guam',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Puerto Rico',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virgin Islands',
    'Virginia',
    'Washington DC',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
  ],
};

export const convertCountryNameToCode = (countries: Array<CountryModel>, country: string | null) => {
  if (country === 'United States') return 'US'; // special case for ZTB
  const matchingHardCodedCountry = countries.find((c) => c.name === country);
  return matchingHardCodedCountry ? matchingHardCodedCountry.code : country;
};

export const validatePhone = (phoneNumber: string) => {
  const pattern = getFormFieldValidations(null).phone;
  return new RegExp(pattern).test(phoneNumber.trim().replace(/\s/, ''));
};

export const getValidationMessage = (validationError: ValidationError, _: string, displayName: string) => {
  if (validationError === 'isInvalid') {
    return displayName === 'phone number' ? (
      <em>{t('client.general.invalid-phone-number')}</em>
    ) : (
      <em>{`This doesn't appear to be a valid ${displayName}`}</em>
    );
  }

  if (validationError === 'isRequired') {
    const vowels = ['a', 'e', 'i', 'o', 'u'];
    const article = vowels.includes(displayName.charAt(0)) ? 'An' : 'A';
    return <em className='error contact-validation-error'>{`${article} ${displayName} is required`}</em>;
  }

  return null;
};
